export const projects = [
  {
    title: "Emocia",
    subtitle: "Swift, ARKit, CoreML",
    info: "Hackathon 2021",
    description:
      "A machine-learning backed iOS app that integrates augmented reality to help children on the autistic spectrum learn and recognize other's emotions",
    image: "https://img.youtube.com/vi/4jyXejf1tQU/hqdefault.jpg",
    link: "https://youtu.be/4jyXejf1tQU",
  },
  {
    title: "Contento",
    subtitle: "Swift and CoreML",
    info: "Technovation semfinalist 2020",
    description:
      "An iOS app to make the lives of senior citizens easier, safer, and better as a whole during quarantine.",
    image: "https://img.youtube.com/vi/Bg-c2IxBM10/hqdefault.jpg",
    link: "https://youtu.be/Bg-c2IxBM10",
  },
  {
    title: "Cloudfree",
    subtitle: "Swift, ARKit",
    description:
      "An augmented-reality 3D iOS game to help people manage anxiety by creating an immersive virtual environment for them to escape to.",
    info: "Hackathon 2021",
    image: "https://img.youtube.com/vi/C7F6eO4Nn1M/hqdefault.jpg",
    link: "https://youtu.be/C7F6eO4Nn1M",
  },
  {
    title: "Skinava",
    subtitle: "Swift, CoreML",
    info: "Hackathon 2021",
    description:
      "An ML-backed application utilizing augmented reality to identify skin conditions.",
    image: "https://img.youtube.com/vi/VgxibDeewZY/hqdefault.jpg",
    link: "https://devpost.com/software/skinava",
  },
  {
    title: "Foodsio",
    subtitle: "Swift, CoreML",
    info: "Best Intermediate Hack - Superposition Hackathon 2021",
    description:
      "An iOS app to help save food wasteage",
    image: "./foodsio.jpg",
    link: "https://devpost.com/software/foodsio",
  },
  {
    title: "Helping Hand",
    subtitle: "Swift, CoreML",
    info: "Technovation 2019",
    description:
      "Aimed at dysgraphic kids, an iOS App that motivates and teaches how to trace letters/numbers with a finger",
    image: "https://img.youtube.com/vi/jLHr7BTfOWU/hqdefault.jpg",
    link: "https://youtu.be/jLHr7BTfOWU",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "./Roadio.jpeg",
    name: "Roadio",
    company: "Roadio",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "./ios.jpg",
    name: "Self Employed",
    company: "Self Employed",
  },
];

export const skills = [
  "Swift, SwiftUI, XCode",
  "Java, C, C++, Python",
  "UIKit, ARKit",
  "CoreML, Tensorflow, Machine Learning",
  "Firebase",
  "Matlab",
  "JavaScript, React, VSCode",
  "Event Organizing"
];


export const activities = [
  {
    image:  "./nsda.png",
    title: "Varsity Public Forum Debate Advanced through elim rounds at multiple major tournaments such as Stanford, Berkeley, Bronx/New York Invitational"
  },
  {
    image:  "./deca.jpg",
    title: "Distributive Education Clubs of America (DECA)"
  }
]

export const MLprojects = [
  {
    title: "Synopsys 2022 Science Fair project",
    subtitle: "Swift, ARKit, CoreML",
    description:
      "Integrated a Python deep reinforcement learning model using Tensorflow for subgrid-scale modelling in large eddy simulations with OpenFoam in C",
    image: "https://img.youtube.com/vi/-JRRAJz5XwE/hqdefault.jpg",
    link: "https://youtu.be/-JRRAJz5XwE",
  },
  {
    title: "Synopsys 2023 Science Fair Project",
    subtitle: "Swift and CoreML",
    description:
      "Utilizing deep reinforcement learning techniques to improve the accuracy of digital holography",
    image: "./sciencefair23.png",
    link: "./sciencefair23.png",
  }
];

export const CircuitProjects = [
  {
    title: "Machine Learning Backed Security Camera System",
    subtitle: "",
    description:
      "This is a Raspberry Pi surveillance project with facial recognition using openCV",
    image: "https://img.youtube.com/vi/tpUzud-5ycc/hqdefault.jpg",
    link: "https://youtu.be/tpUzud-5ycc",
  },
  {
    title: "Muscle-Powered Prosthetic Arm Showcase",
    subtitle: "",
    description:
      "This is a 3D printed prosthetic hand muscle powered with arduino and servo motor that can open and close.,",
    image: "https://img.youtube.com/vi/tAT2gFmcftM/hqdefault.jpg",
    link: "https://www.youtube.com/watch?v=tAT2gFmcftM",
  },

  {
    title: "Muscle-Powered Prosthetic Arm Demo",
    subtitle: "",
    description:
      "This is a 3D printed prosthetic hand muscle powered with arduino and servo motor that can open and close.,",
    image: "https://img.youtube.com/vi/OqHHCSEdBmU/hqdefault.jpg",
    link: "https://www.youtube.com/watch?v=OqHHCSEdBmU",
  },

  {
    title: "VEX Robotics",
    subtitle: "",
    description:
      "Built 2019-2020 VRC Robotic challenge robot that can stack a large number of cubes. ",
    image: "./VEX.jpg",
    link: "https://www.vexrobotics.com/v5/competition/vrc-current-game",
  }
];

export const work = [
  {
    title: "Chapter Founder and President",
    subtitle: "Supernova Lynbrook",
    description:
      "Women make up only 28% of the STEM workforce, despite earning 57% of bachelor’s degrees. You can help change that. "
      + "At Supernova Lynbrook, a non-profit organization we aim to bridge the gender gap by creating opportunities for young women to explore STEM."
      
      +"- Teach free classes Java to over 20 middle school and high school students every week"
      +"- Organize guest speaker events, classes, workshops and hackathons",
    image: "./supernovalyn.png",
    link: "https://www.linkedin.com/company/supernova-lynbrook/",
    date: "2019 - Present"
  },
  {
    title: "Software Engineer Machine Learning Intern",
    subtitle: "Roadio",
    description:
      "Roadio makes a vision system for bikes that acts as a dashcam and uses AI-powered alerts to prevent collisions"
      + "Improved Roadios SSD (Single Shot MultiBox Detector) machine learning model part of the vision pipeline for vehicle detection"
      + "to specifically identify heavy vehicles (trucks and buses)",
    image: "./Roadio.jpeg",
    link: "http://www.roadio.ai",
    date: "June 2022 - August 2022",
  },
  {
    title: "iOS App Developer & Machine learning Enthusiast",
    subtitle: "Self Employed",
    description:
      "Worked on several iOS Apps",
    image: "./ios.jpg",
    link: "#projects",
    date: "2019 - Present"
  },
  {
    title: "Co-Founder, CTO and CFO",
    subtitle: "Great Grams",
    description:
    "Great grams is a business our team started as part of Virtual Business Enterprise class at Lynbrook high school."
    + "Our business sells seasonal grams for students throughout the school year. "
   + "I host and manage our business website, manage transactions and finances for the company."
   + " I am also part of  utting together the grams for different seasons, marketing and selling them.",
    image: "./great_grams.png",
    link: "https://www.linkedin.com/company/supernova-lynbrook/",
    date: "2022 - Present"
  },

  {
    title: "National Honor Society STTAR Tutor",
    subtitle: "Lynbrook High School",
    description:
      "Tutor high school kids for English, Math, Physics and Computer Science",
    image: "./Lynbrook.png",
    link: "https://lhs.fuhsd.org/guidance-student-support/sttar-tutoring",
    date: "2022 - Present"
  },

  {
    title: "Multiple Leadership positions (President, VP Programs, VP Philanthropy)",
    subtitle: "National Charity League",
    description:
      "Held multiple leadership positions at NCL Heritage Oaks",
    image: "./ncl.png",
    link: "https://www.nationalcharityleague.org/chapter/heritageoaks/",
    date: "2018 - Present"
  }
];

export const awards = [
  "AP Scholar with Distinction (July 2023)",
  "Presidential Volunteer Service Award - Gold (January 2023 & January 2022)",
  "National Honor Society (2022)",
  "Synopsys Science Fair ACM Upper Division Award (March 2022)",
  "Best Environment Hack (Blair Hacks 5 2022)",
  "DECA SCDC: 4th Place in Business Management and Administration Roleplay (March 2021)",
  "DECA SVCDC: 6th Place Innovation Plan (Jan 2021)",
  "Varsity Public Forum: Placed in elim rounds at many major tournaments (2019-2021)",
  "Taekwondo - Black Stripe (September 2020)",
  "Technovation Global App Competition Semifinalist (May 2020)",
  "Best Intermediate Hack (Superposition 1V 2020)",
  "Vex Robotics: Judges Award (Jan 2020)",
  "Best UI and Third Place (PacHacks 2019)",
  "Best Beginner Hack (Superposition III 2019)",
  "Best Middle school Hack (Superposition II 2018)"
];

export const images = [
  {
    image:  "./supernova1.jpeg",
    title: "Girls working in hackathon"
  },
  {
    image:  "./supernova2.jpeg",
    title: "Motivational Keynote Speaker"
  },
  {
    image:  "./supernova4.jpeg",
    title: "ML Workshop"
  },
  {
    image:  "./supernova5.jpeg",
    title: "Sleep Workshop"
  },

  {
    image:  "./supernova7.jpeg",
    title: "Mentoring in hackathon"
  },
  {
    image:  "./supernova8.jpeg",
    title: "Closing note"
  },
  {
    image:  "./supernova9.jpeg",
    title: "Awards ceremony"
  },
  {
    image:  "./supernova3.jpeg",
    title: "Awards ceremony"
  },
  {
    image:  "./supernova10.jpg",
    title: "Supernova Hackathon"
  },
];

export const hobbies = [
  "Carnatic Vocal music (Learning carnatic vocal music for the past 10 years)",
  "Taekwondo Black Stripe (Testing for Black belt, learning for the past 8 years)",
  "Bhrathanatyam (Learned and practiced Indian classical dance for 6 years)",
  "Music Analysis",
  "Reading",
  "Running & Strength training (Participated in cross country and track & field)"
];
